var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeSlash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.97499C14.79 3.97499 18.17 6.10499 19.82 9.47499C19.23 10.695 18.4 11.745 17.41 12.595L18.82 14.005C20.21 12.775 21.31 11.235 22 9.47499C20.27 5.08499 16 1.97499 11 1.97499C9.73 1.97499 8.51 2.17499 7.36 2.54499L9.01 4.19499C9.66 4.06499 10.32 3.97499 11 3.97499ZM9.93 5.11499L12 7.18499C12.57 7.43499 13.03 7.89499 13.28 8.46499L15.35 10.535C15.43 10.195 15.49 9.83499 15.49 9.46499C15.5 6.98499 13.48 4.97499 11 4.97499C10.63 4.97499 10.28 5.02499 9.93 5.11499ZM1.01 1.84499L3.69 4.52499C2.06 5.80499 0.77 7.50499 0 9.47499C1.73 13.865 6 16.975 11 16.975C12.52 16.975 13.98 16.685 15.32 16.155L18.74 19.575L20.15 18.165L2.42 0.424988L1.01 1.84499ZM8.51 9.34499L11.12 11.955C11.08 11.965 11.04 11.975 11 11.975C9.62 11.975 8.5 10.855 8.5 9.47499C8.5 9.42499 8.51 9.39499 8.51 9.34499ZM5.11 5.94499L6.86 7.69499C6.63 8.24499 6.5 8.84499 6.5 9.47499C6.5 11.955 8.52 13.975 11 13.975C11.63 13.975 12.23 13.845 12.77 13.615L13.75 14.595C12.87 14.835 11.95 14.975 11 14.975C7.21 14.975 3.83 12.845 2.18 9.47499C2.88 8.04499 3.9 6.86499 5.11 5.94499Z",
    fill: "#ABB5BE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/EyeSlash.3a222757.svg";
export { ForwardRef as ReactComponent };